$(document).ready(function(){
  
  // Select all block items
  // var $blockItems = $('.index2Main:not(.nowwrap) .coll_item');
  // if ($blockItems.length >= 4) {
  //   $blockItems.slice(-2).wrapAll('<div class="last-two-wrapper"></div>');
  // }

 
  function addWrap() {
    // Function to update the text and class of the custom button
    function updateButton() {
      let originalText = $('.btnWrapBx+div .product-form__submit span').text();
      let inventoryText = $('.product__info-container .product__inventory .inv_sts').text();
  
      // Update the text of the custom button
      $('#adtBtn').text(originalText);
  
      // Check and update the class based on inventory status or button text
      if (inventoryText === "Out of stock" || originalText === "Sold Out") {
        $('#adtBtn').addClass('sold-out'); // Add 'sold-out' class if conditions are met
      } else {
        $('#adtBtn').removeClass('sold-out'); // Remove 'sold-out' class otherwise
      }
    }
  
    // Use MutationObserver to watch for changes in the original button text
    let targetElement = $('.product-form__submit span')[0];
    if (targetElement) {
      let observer = new MutationObserver(updateButton);
      observer.observe(targetElement, { childList: true, subtree: true });
    }

    // Add a click event to the custom button to trigger the original button's click
    $('#adtBtn').click(function() {
      $('.btnWrapBx+div .product-form__submit').trigger("click");
    });
  
    // Fallback: Use setInterval to check and update periodically
    let checkInterval = setInterval(function() {
      if ($('.btnWrapBx+div .product-form__submit span').text()) {
        updateButton();
        clearInterval(checkInterval); // Stop checking once the text is loaded
      }
    }, 100); // Adjust the interval as needed
  }
  
  // Run the addWrap function after a short delay to ensure elements are loaded
  setTimeout(addWrap, 100);



  // FAQ accordion 
  $(".faq_content:first-of-type").addClass("open");
  $(".faq_content:first-of-type .faq_title").addClass("active");
  $(".faq_content:first-of-type .faq_text").slideDown();
  $(".faq_content .faq_title").click(function(){
    $(this).parent().siblings().find(".faq_title").removeClass("active");
    $(this).parent().siblings().find(".faq_text").slideUp();
    $(this).parent().siblings().removeClass("open");
    $(this).toggleClass("active");
    $(this).next(".faq_text").slideToggle();
    $(this).parent().toggleClass("open");
  });
  // FAQ accordion
  
  // Troubleshoot FAQ accordion Load more functionality
  $(".cont_faq_content").slice(0, 6).show();
  $("#loadMore").click(function(e){
    e.preventDefault();
    // Show the next 6 hidden boxes
    $(".cont_faq_content:hidden").slice(0, 6).show();
    // If there are no more hidden boxes, hide the Load More button
    if ($(".cont_faq_content:hidden").length == 0) {
      $("#loadMore").fadeOut("slow");
    }
  });
  // Troubleshoot FAQ accordion Load more functionality
});